import { getClient } from '@graphql/graphql-client/graphClient';
import {useConversationsListQuery} from '@graphql/generated-graphql';
import { useMemo } from 'react';

export const useConversationsData = () => {
  const listQuery = useConversationsListQuery(getClient('communication'));

  const unreadChatsCount = useMemo(() => {
    return listQuery.data?.conversations?.filter((c) => !c?.isViewed)?.length || 0;
  }, [listQuery.data]);

  return {conversationsData: listQuery.data, conversationsLoading: listQuery.isLoading, conversationsRefetching: listQuery.isRefetching, unreadChatsCount}
}